// strings/auth.ts (M0-T06, §7.1) — sign-in. noteCode / noteInvite (title polish, 2026-10-06): how sign-in and towns work, beside the field
import type { StringBank } from '../schema/strings';

export default {
  title: 'Welcome to {app}', subtitle: 'Sign in to visit your towns.', emailLabel: 'Email', emailPlaceholder: 'you@example.com',
  sendCode: 'Send me a code', codeSent: 'We sent a 6-digit code to {email}.', codeLabel: '6-digit code', signIn: 'Sign in',
  or: 'or', apple: 'Sign in with Apple', wrongCode: "That code didn't work. Check it and try again.", resend: 'Send a new code',
  changeEmail: 'Use a different email', checking: 'Signing you in…', invalidEmail: 'Enter a valid email address.',
  noteCode: 'No password needed. We email you a 6-digit code to sign in.',
  noteInvite: 'Towns are invite-only, so only friends you ask can move in.',
  invited: "You've been invited to a town", invitedCode: 'Invite {code} — sign in to see the town and move in.',
} as const satisfies StringBank;
